import { render, staticRenderFns } from "./UserFakeSelect.vue?vue&type=template&id=5e6e4239&scoped=true&"
import script from "./UserFakeSelect.vue?vue&type=script&lang=js&"
export * from "./UserFakeSelect.vue?vue&type=script&lang=js&"
import style0 from "./UserFakeSelect.vue?vue&type=style&index=0&id=5e6e4239&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6e4239",
  null
  
)

export default component.exports